/// <amd-module name="VSS/Features/MarkdownHighlight/MarkdownHighlightService" />
import * as MarkdownHighlight from "highlight";

import { VssService, Services } from "VSS/Platform/Context";

import { IMarkdownHighlightService } from "VSS/Features/MarkdownHighlight/IMarkdownHighlightService";

class MarkdownHighlightService extends VssService implements IMarkdownHighlightService {
    public highlight(code: string, language: string): string {
        return MarkdownHighlight.highlight(language, code, true).value;
    }
}

Services.add("markdown-highlight-service", { serviceFactory: MarkdownHighlightService });
